// Combo chart bar+line via composition API di `@mui/x-charts` (v9:
// ChartsDataProvider + ChartsSurface). Copre il caso "due metriche su scale
// molto diverse" (es. fatturato ~20k€ vs prezzo medio ~40€), dove due serie a
// barre sulla stessa scala schiaccerebbero la più piccola fino a sparire:
// barre su un asse, linea sull'altro.
//
// Le serie vanno passate già tipizzate ({ type: 'bar' | 'line', ... }) e
// agganciate a un asse via `yAxisId`; ogni voce di `yAxis` deve avere `id` e
// `position` ('left' | 'right').
import {
  BarPlot,
  ChartsDataProvider,
  ChartsGrid,
  ChartsLegend,
  ChartsSurface,
  ChartsTooltip,
  ChartsWrapper,
  ChartsXAxis,
  ChartsYAxis,
  LinePlot,
  MarkPlot,
} from '@mui/x-charts';

export default function ComboBarLineChart({ dataset, xAxis, yAxis = [], series = [], ...rest }) {
  return (
    <ChartsDataProvider dataset={dataset} xAxis={xAxis} yAxis={yAxis} series={series} {...rest}>
      <ChartsWrapper>
        <ChartsLegend />
        <ChartsSurface>
          <ChartsGrid horizontal />
          <BarPlot />
          <LinePlot />
          <MarkPlot />
          <ChartsXAxis />
          {yAxis.map((axis) => (
            <ChartsYAxis key={axis.id} axisId={axis.id} />
          ))}
        </ChartsSurface>
        <ChartsTooltip />
      </ChartsWrapper>
    </ChartsDataProvider>
  );
}
